import { FastForward, Gavel, ShieldAlert } from 'lucide-react';
import { characterById } from '../case/case001';
import { COURT_EVENT_SCRIPTS, getCourtEventBeat, getCourtEventProgress } from '../game/courtEvents';
import { useGame } from '../game/GameContext';

export function CourtEventOverlay() {
  const { state, dispatch } = useGame();
  const event = state.courtEvent;
  if (!event) return null;
  const script = COURT_EVENT_SCRIPTS[event.id];
  const beat = getCourtEventBeat(event);
  const speaker = characterById[beat.speakerId];
  const danger = event.id === 'rook-lunge' && event.elapsedMs >= 1800 && event.elapsedMs < 5000;

  return (
    <section className={`court-event screen-layer screen-layer--passthrough ${danger ? 'is-danger' : ''}`}>
      <div className="court-event__bar court-event__bar--top" />
      <div className="court-event__bar court-event__bar--bottom" />
      <header>
        {danger ? <ShieldAlert /> : <Gavel />}
        <div><span>LIVE COURT EVENT</span><strong>{script.title}</strong></div>
      </header>
      {state.audio.subtitles && (
        <div className="court-event__subtitle" key={beat.atMs}>
          <span>{beat.label}</span>
          <p>{beat.line}</p>
          <i><b style={{ width: `${getCourtEventProgress(event) * 100}%` }} /></i>
        </div>
      )}
      <button className="reveal-skip hud-interactive" onClick={() => dispatch({ type: 'SKIP_COURT_EVENT' })}>
        <FastForward /> Continue testimony
      </button>
      <div className="court-event__speaker">{speaker.name}</div>
      {danger && <div className="court-event__impact" />}
    </section>
  );
}
